// extracted by mini-css-extract-plugin
export default {"header":"_44ea90dc"};